module.exports = __webpack_public_path__ + "static/media/A-tu-Lado.eef4ebbb.svg";